import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface BookingEngineOverlayData {
  from?: string;
  to?: string;
  jobId?: string;
  locationType?: string;
  activityType?: string;
  requestedArrival?: string;
  requestedDeparture?: string;
  estimatedDurationMin?: number;
}

@Component({
  selector: 'hmt-booking-engine-overlay',
  templateUrl: './booking-engine-overlay.component.html',
  standalone: false,
  styleUrls: ['./booking-engine-overlay.component.scss']
})
export class BookingEngineOverlayComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<BookingEngineOverlayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BookingEngineOverlayData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}


